import { mutation, query } from "../../utils/responseHandler";
import api from "./ApiService";
import SessionService from "./SessionService";

export default class GameService {
  static async listGames(search, limit = 100, offset = 0) {
    let response = await api(
      `query {
        auth(token: "${SessionService.get("token")}") {
          listGames(
            search: "${search}",
            limit: ${limit},
            offset: ${offset}
          ) {
            type
            slug
            title
            description
            theme
            image
            locked
            overlay
            overlay_text
            banner
          }
        }
      }`
    );
    return query.responseHandler(response, "listGames", true);
  }

  static async getGame(slug) {
    let response = await api(
      `query {
        auth(token: "${SessionService.get("token")}") {
          getGame(slug: "${slug}") {
            type
            slug
            background {
              desktop
              mobile
            }
            intro
            share {
              title
              text
              url
            }
            locked
            game
          }
        }
      }`
    );
    return query.responseHandler(response, "getGame", true);
  }

  static async initGameStatistics(slug, type) {
    let response = await api(
      `mutation {
        authMutation(token: "${SessionService.get("token")}") {
          create{
            initGameStatistics(slug:"${slug}", type: "${type}")
          }
        }
      }`
    );
    return mutation.responseHandler(
      response,
      "initGameStatistics",
      "create",
      true
    );
  }

  static async submitGameStatistics(id, start, end, score = null, stats = {}) {
    let response = await api(
      `mutation submitGameStats($stats: String!) {
        authMutation(token: "${SessionService.get("token")}") {
          update{
            submitGameStatistics(id:"${id}",start:"${start}", end:"${end}", score:${score}, statistics: $stats)
          }
        }
      }`,
      { stats: JSON.stringify(stats) }
    );
    return mutation.responseHandler(
      response,
      "submitGameStatistics",
      "update",
      true
    );
  }

  static async getGameSession(slug) {
    let response = await api(
      `query {
        auth(token: "${SessionService.get("token")}") {
          getGameSession(slug: "${slug}") {
            ref
            done
            step
            response
            recommendations {
              date
              text
              inputs
              list {
                kind
                slug
                title
              }
            }
            game {
              slug
              share {
                title
                text
                url
              }
              game
            }
          }
        }
      }`
    );
    const data = query.responseHandler(response, "getGameSession", true);
    data.data.response = JSON.parse(data.data.response);
    data.data.game.game = JSON.parse(data.data.game.game);
    return data;
  }

  static async dynamic({ query: gqlQuery, variables, path }, data) {
    variables.token = SessionService.get("token");
    if (Object.keys(variables).includes("payload")) variables.payload = data;
    let response = await api(gqlQuery, variables),
      [queryType, , mutationType, method] = path.split(".");
    const resp =
      queryType === "mutation"
        ? mutation.responseHandler(response, method, mutationType, true)
        : query.responseHandler(response, mutationType, true);
    if (typeof resp.data !== typeof false && !Array.isArray(resp.data))
      resp.data.game.game = JSON.parse(resp.data.game.game);
    return resp;
  }
}
